/**
 * Scroll-position-based mobile dot indicator for gallery <slider-grid> elements
 * in slideshow mode. Replaces the SliderGrid component's IntersectionObserver
 * logic which fails on snap-back (dots drift / get stuck after scrolling to
 * the end and returning).
 *
 * For each .slider-grid that contains slideshow dots:
 *   - Listens to scroll on the slider-grid-track child
 *   - On scroll, picks the slide whose center is closest to the track viewport
 *     center, and toggles `.is-primary` on the matching dot
 *
 * Throttled with requestAnimationFrame. Runs after a single section:load to
 * avoid racing the theme's own init.
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 768;

  function isMobile() {
    return window.matchMedia('(max-width: ' + (MOBILE_BREAKPOINT - 1) + 'px)').matches;
  }

  function findActiveIndex(track, slides) {
    if (!slides.length) return 0;
    var trackRect = track.getBoundingClientRect();
    var center = trackRect.left + trackRect.width / 2;
    var bestIdx = 0;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var r = slides[i].getBoundingClientRect();
      var slideCenter = r.left + r.width / 2;
      var dist = Math.abs(slideCenter - center);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    }
    return bestIdx;
  }

  function setActiveDot(dots, index) {
    for (var i = 0; i < dots.length; i++) {
      var dotIdx = parseInt(dots[i].getAttribute('index'), 10);
      dots[i].classList.toggle('is-primary', dotIdx === index);
    }
  }

  function attach(grid) {
    if (grid.dataset.cnDotsAttached === '1') return;

    var track = grid.querySelector('[slider-grid-track]');
    var dots = grid.querySelectorAll('[slider-grid-dot]');
    var slides = grid.querySelectorAll('[slider-grid-slide][index]');

    if (!track || dots.length === 0 || slides.length === 0) return;

    grid.dataset.cnDotsAttached = '1';

    var rafId = null;
    function update() {
      rafId = null;
      if (!isMobile()) return;
      var idx = findActiveIndex(track, slides);
      setActiveDot(dots, idx);
    }
    function onScroll() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(update);
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    // Initial sync after layout settles
    requestAnimationFrame(function () { requestAnimationFrame(update); });
  }

  function init(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var grids = scope.querySelectorAll('slider-grid');
    for (var i = 0; i < grids.length; i++) {
      // Only attach to grids that have slideshow dots rendered
      if (grids[i].querySelector('[slider-grid-dot]')) {
        attach(grids[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
  document.addEventListener('shopify:section:select', function (e) {
    init(e.target || document);
  });
})();
